"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _pureReactCarousel = require("pure-react-carousel");

require("pure-react-carousel/dist/react-carousel.es.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  slideshow: {
    position: "relative",
    maxWidth: props => {
      return props.maxWidth;
    },
    margin: "auto"
  },
  slider: {
    "& ul": {//            margin: 0
    }
  },
  navigation: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  dots: {
    position: "absolute",
    right: 0,
    left: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center"
  },
  backButton: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0
  },
  nextButton: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0
  }
}));

const LayoutSlideshow = ({
  className,
  spacing = 2,
  padding = 0,
  maxWidth = 720,
  mediaFormat = "2:1",
  children
}) => {
  const classes = useStyles({
    spacing,
    padding,
    maxWidth
  });
  const totalSlides = children && children.length;
  const format = mediaFormat.split(':');
  return _react.default.createElement(_pureReactCarousel.CarouselProvider, {
    className: className || classes.slideshow,
    naturalSlideWidth: format[0],
    naturalSlideHeight: format[1],
    totalSlides: totalSlides
  }, _react.default.createElement(_pureReactCarousel.Slider, {
    className: classes.slider
  }, children.map((child, index) => {
    const item = _react.default.cloneElement(child, {
      mediaFormat: mediaFormat
    });

    return _react.default.createElement(_pureReactCarousel.Slide, {
      index: index
    }, item);
  })), _react.default.createElement("nav", {
    className: classes.navigation
  }, _react.default.createElement(_pureReactCarousel.DotGroup, {
    className: classes.dots
  }), _react.default.createElement(_pureReactCarousel.ButtonBack, {
    className: classes.backButton
  }, "Back"), _react.default.createElement(_pureReactCarousel.ButtonNext, {
    className: classes.nextButton
  }, "Next")));
};

var _default = LayoutSlideshow;
exports.default = _default;
module.exports = exports.default;